import React, { Component } from 'react'
import { Button, Icon, Row, Input, Col } from 'react-materialize'

class Login extends Component {
  state = {
    valueUsername: '',
    valuePassword: '',
    failed: false
  }

  resetFields = () => {
    this.setState({
      failed: false,
      valueUsername: '',
      valuePassword: ''
    })
  }

  logout = () => {
    this.setState({
      failed: false,
      valueUsername: '',
      valuePassword: ''
    })
    this.props.logout()
  }

  checkPassword = () => {
    if (
      this.state.valueUsername === 'phoenix' &&
      this.state.valuePassword === 'phoenix'
    ) {
      this.props.login()
      return this.setState({
        valueUsername: '',
        valuePassword: '',
        failed: false
      })
    }

    this.setState({
      failed: true
    })
  }

  userName = e => {
    this.setState({
      valueUsername: e.target.value
    })
  }

  password = e => {
    this.setState({
      valuePassword: e.target.value
    })
  }

  render() {
    return (
      <div style={{ margin: '30px 0' }}>
        <h4>Login to continue</h4>

        <Row>
          <Col s={5}>
            <Input
              label="username"
              s={12}
              value={this.state.valueUsername}
              onChange={this.userName}
            />
            <Input
              type="password"
              label="password"
              s={12}
              value={this.state.valuePassword}
              onChange={this.password}
            />
          </Col>
        </Row>

        {!this.props.loginState && (
          <Button waves="light" onClick={this.checkPassword}>
            <Icon>done</Icon>
          </Button>
        )}

        {this.props.loginState && (
          <div>
            <div className="col s12">
              <div className="card horizontal">
                <div className="card-stacked">
                  <div className="card-content">
                    <p>Welcome back</p>
                  </div>
                  <div className="card-action">
                    <Button waves="light" onClick={this.logout}>
                      <Icon>cancel</Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <span style={{ padding: '0 10px' }} />

        {this.state.failed && (
          <div>
            <div className="col s12">
              <div className="card horizontal">
                <div className="card-stacked">
                  <div className="card-content">
                    <p>Login failed</p>
                  </div>
                  <div className="card-action">
                    <Button waves="light" onClick={this.resetFields}>
                      <Icon>update</Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default Login
